import React, { useState, useEffect } from 'react';
import { useHistory, useParams, useLocation } from "react-router-dom";
import axios from 'axios';
import Tools from './Tools';
import UserMenu from './UserMenu';
import Sidebar from './Sidebar';
import Popover from './ui/Popover';
import IconView from './icons/IconView';
import Alert from './Alert';
import MoreMenu from './ui/moreMenu/MoreMenu';
import ModalWindow from './ModalWindow';
import Trash from './icons/Trash';
import {Warning} from '../components/icons/svgIcons';
import { ReactComponent as IconInboundSearch } from './icons/inboundSearch.svg';

import './css/Home.css';

const ClientsSearch = (props) => {
    const { inboundQueue } = useParams();
    const { phone } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const [clients, setClients] = useState([]);
    const [searchValue, setSearchValue] = useState(queryParams.get('q') || null);
    const [searchKey, setSearchKey] = useState(queryParams.get('key') || 'PHONES');
    const [clientStatus, setClientStatus] = useState(queryParams.get('status') || '1');
    const [lastSearchValue, setLastSearchValue] = useState(null);
    const [lastSearchKey, setLastSearchKey] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [editPhonesClient, setEditPhonesClient] = useState(null);
    const history = useHistory();

    useEffect(() => {
        if (queryParams.get('q') && !inboundQueue && !phone) {
            getClientsSearch();
        }
    }, []);

    useEffect(() => {
        if(inboundQueue && phone){
            let serviceParams = {}
            serviceParams.inboundQueue=inboundQueue;
            serviceParams.phone=phone;
            setLoading(true);

            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/clientsByInboundQueueAndPhone`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                params: serviceParams
            };

            axios(options).then((response) => {
                setClients(response.data); 
                setLoading(false);
                setLastSearchValue(serviceParams.phone);
            })
            .catch((error) => {
                console.log("Error:", error.message);
                setError(error.message);
                setLoading(false);
            });
        }
    }, []);

    const calculateRutDv = (rut) => {
        const rutDigits = String(rut).replace(/[^0-9]/g, '');
        if (!rutDigits) return '';

        let sum = 0;
        let multiplier = 2;

        for (let i = rutDigits.length - 1; i >= 0; i--) {
            sum += parseInt(rutDigits.charAt(i), 10) * multiplier;
            multiplier = multiplier === 7 ? 2 : multiplier + 1;
        }

        const remainder = sum % 11;
        const dv = 11 - remainder;

        if (dv === 11) return '0';
        if (dv === 10) return 'K';
        return String(dv);
    };

    const normalizeRutForSearch = (value, currentSearchKey) => {
        if (currentSearchKey !== 'RUT_SIN_DV') {
            return value || '';
        }

        const trimmedValue = (value || '').trim();
        if (!trimmedValue) return '';

        const rutDigits = trimmedValue.replace(/[^0-9]/g, '');
        if (!rutDigits) return '';

        return `${rutDigits}-${calculateRutDv(rutDigits)}`;
    };

    const getClientsSearch = (campaign, overrideSearchValue) => {

        let serviceParams = {}

        const activeSearchValue = overrideSearchValue ?? searchValue;

        if (activeSearchValue) {
            serviceParams.searchValue = activeSearchValue.trim();
            serviceParams.searchKey = searchKey === 'RUT_SIN_DV' ? 'RUT' : searchKey;
        }

        setLoading(true);

        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/clientsByKey`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: serviceParams
        };

        axios(options).then((response) => {
            setClients(response.data); 
            setLoading(false);

            setLastSearchKey(serviceParams.searchKey);
            setLastSearchValue(serviceParams.searchValue);
            setSearchValue(serviceParams.searchValue || '');
        })
        .catch((error) => {
            console.log("Error:", error.message);
            setError(error.message);
            setLoading(false);
        });
    }

    const handleSearchChange = (event) => {
        setSearchValue(event.target.value);
    }

    const search = () => {
        const normalizedSearchValue = normalizeRutForSearch(searchValue, searchKey);
        const params = new URLSearchParams();
        if (normalizedSearchValue) params.set('q', normalizedSearchValue);
        params.set('key', searchKey === 'RUT_SIN_DV' ? 'RUT' : searchKey);
        params.set('status', clientStatus);
        history.replace({ search: params.toString() });
        setSearchValue(normalizedSearchValue);
        getClientsSearch(null, normalizedSearchValue);
    }

    const validateAndFormatRut = (event) => {
        const dv = (T) => {
            var M = 0, S = 1; for (; T; T = Math.floor(T / 10))
                S = (S + T % 10 * (9 - M++ % 6)) % 11; return S ? S - 1 : 'k';
        }

        let currentValue = event.target.value;
        currentValue = currentValue.replace(/[^0-9,k,K]+/g, "");

        if (currentValue.length > 1) {
            currentValue.replaceAll('-', '');
            currentValue = currentValue.substr(0, currentValue.length - 1) + '-' + currentValue.substr(currentValue.length - 1, 1);
            let rutParts = currentValue.split('-');

            if (currentValue.length > 5 && !isNaN(rutParts[0])) {
                currentValue = `${Intl.NumberFormat('ES-CL', { currency: 'CLP' }).format(rutParts[0])}-${rutParts[1]}`;
            }

            if (dv(rutParts[0]).toString() === rutParts[1].toString() && !isNaN(rutParts[0])) {
                event.target.setCustomValidity('');
            } else {
                event.target.setCustomValidity("invalid rut");
            }
        }

        event.target.value = currentValue;

        //build format for searches
        let formatForSearch = currentValue.replace(/[^0-9,k,K]+/g, "");
        formatForSearch = formatForSearch.substr(0, formatForSearch.length - 1) + '-' + formatForSearch.substr(formatForSearch.length-1,1);
        setSearchValue(formatForSearch);
    }

    const assignToGenericInboundCampaign = (client) => {
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/clientGenericCampaign`,
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            data: {
                rowId: client._id,
                companyId: client.CNY_DETAILS._id,
                assignmentId:client.assignmentId
            }
        };
        
        axios(options).then(response => {

            if (response.status === 200) {
                // if(phone){
                //     history.push("/" + response.data.genericCampaign + "/" + client.clientId + "/" + phone);
                // } else {
                //     if(lastSearchKey==='PHONES' && lastSearchValue){
                //         history.push("/" + response.data.genericCampaign + "/" + client.clientId + "/" + searchValue);
                //     } else{
                //         history.push("/" + response.data.genericCampaign + "/" + client.clientId);
                //     }
                // }

                
                //INCLUYE STATUS PARA PODER CONSULTAR CLIENTES VIGENTES Y NO VIGENTES
                if(phone){
                    history.push("/search/" + response.data.genericCampaign + "/" + client.clientId + "/" + phone + "/" + client.status); 
                } else {
                    if(lastSearchKey==='PHONES' && lastSearchValue){
                        history.push("/search/" + response.data.genericCampaign + "/" + client.clientId + "/" + searchValue + "/" + client.status); 
                    } else{
                        //FUERZA INCLUSION DE TELEFONO, PORQUE SI SOLO TIENE 3 NIVELES, NO SE SABRIA SI EL ULTIMO PARAMETRO ES TELEFONO O STATUS
                        history.push("/search/" + response.data.genericCampaign + "/" + client.clientId + "/" + client.contacto.phones[0] + "/" + client.status); 
                    }
                }
            }
        })
        .catch(function (error) {
            setError(error.response.data);
            setLoading(false);
        });
    }

    const deactivateClient = (clientId) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/client/deactivate/${clientId}`,
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            }
        };

        axios(options).then(() => {
            getClientsSearch();
        })
        .catch((error) => {
            console.log("Error:", error.message);
            setError(error.message);
        });
    }

    const editClientPhones = (client) => {
        setEditPhonesClient(client);
    };

    const deletePhoneFromClient = (clientId, phone) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/client/${clientId}/phone`,
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: { phone }
        };

        axios(options).then(() => {
            setEditPhonesClient(prev => ({
                ...prev,
                contacto: {
                    ...prev.contacto,
                    phones: prev.contacto.phones.filter(p => p !== phone)
                }
            }));
            setClients(prev => prev.map(c =>
                c._id === clientId
                    ? { ...c, contacto: { ...c.contacto, phones: c.contacto.phones.filter(p => p !== phone) } }
                    : c
            ));
        }).catch((error) => {
            console.log("Error:", error.message);
            setError(error.message);
        });
    };

    return (
        <div className="mainWrapper">
            <Sidebar key={props.inboundConnectedQueues} current="10" softphoneConnectionStatus={props.softphoneConnectionStatus}/>
            <div className="main">
                <div className="headerWrapper">
                    <div className="titleWrapper">
                        <h1 className={loading?'loading':''}><IconInboundSearch/>Búsqueda clientes inbound</h1>
                    </div>
                    <UserMenu setInboundConnectedQueues={props.setInboundConnectedQueues}/>
                </div>

                {error?(
                    <Alert className="error mgb20">Error: {error}</Alert>
                ):null}

                <div className="searchWrapper">
                    {searchKey !=='RUT' && searchKey !== 'RUT_SIN_DV' ? (
                        <input type="search" name="q" placeholder="Ingrese un patrón de búsqueda..." size="60" value={searchValue || ''} onChange={handleSearchChange}/>
                    ) : (
                        <input className="rut" type="search" name="q" placeholder={searchKey === 'RUT' ? 'Ingrese Rut' : 'Ingrese Rut sin DV'} size="60" value={searchValue || ''} onChange={(e) => searchKey === 'RUT' ? validateAndFormatRut(e) : handleSearchChange(e)} maxLength="13" />
                    )}

                    <select className='simple' name='searchKey' value={searchKey} onChange={(e)=>setSearchKey(e.target.value)}>
                        <option value="PHONES">Telefono(s)</option>
                        <option value="EMAIL">EMail</option>
                        <option value="RUT">Rut</option>
                        <option value="RUT_SIN_DV">Rut sin DV</option>
                    </select>

                    <select className='simple' name='clientStatus' value={clientStatus} onChange={(e)=>setClientStatus(e.target.value)}>
                        <option value="1">Vigente</option>
                        <option value="0">No Vigente</option>
                        <option value="-1">Cualquiera</option>
                    </select>

                    <button className='default' onClick={() => search()} disabled={!searchValue?.trim()}>Buscar</button>
                </div>

                <div className="tableWrapper">
                    <table className="fullWidth">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Rut</th>
                                <th>Nombre cliente</th>
                                <th>VIGENTE</th>
                                {searchKey === 'PHONES' ? (
                                    <th>Teléfonos</th>
                                ) : searchKey ==='EMAIL'?(
                                    <th>Mail</th>
                                ):null}

                                <th>Empresa</th>
                                <th>Asignación</th>
                                <th colSpan={2}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {clients.map((listValue, index) => {
                                return (
                                    clientStatus==='-1' || String(listValue.status)===clientStatus?(
                                    <tr key={index}>
                                        <td align="right">{index+1}</td>
                                        <td>{listValue.clientId}</td>
                                        <td>{listValue.clienteNombre} {listValue.clienteApPat} {listValue.clienteApMat}</td>
                                        <td>{listValue.status===1?'VIGENTE':'NO VIGENTE'}</td>
                                        {searchKey === 'PHONES' ? (
                                            <td dangerouslySetInnerHTML={
                                                {__html:listValue.contacto.phones?.reduce((a, b) => {
                                                        if (b ===searchValue){
                                                            return a + '<br/><b>' + b + '</b>';
                                                        } else {
                                                            return a + '<br/>' + b;
                                                        }
                                                    })
                                                }
                                            }></td>
                                        ) : searchKey === 'EMAIL' ? (
                                            <td>{listValue.contacto.correo}</td>
                                        ) : null}

                                        <td>
                                            <span className='companyColor' style={{borderColor:listValue.CNY_DETAILS.color}}>{listValue.CNY_DETAILS.name}</span>
                                        </td>
                                        <td className='wsNormal'>{listValue.ASSGN_DETAILS.date} ({listValue.ASSGN_DETAILS.name})</td>
                                        <td>
                                            <a className="link" onClick={() => {assignToGenericInboundCampaign(listValue)}}>Seleccionar</a>
                                        </td>
                                        <td>
                                            <MoreMenu menuList={[
                                                { title: `Bloquear`, action: () => deactivateClient(listValue._id), visible: true },
                                                { title: `Editar teléfonos`, action: () => editClientPhones(listValue), visible: true }
                                            ]}/>
                                        </td>
                                    </tr> 
                                    ):null 
                                );      
                            })}   
                        </tbody>            
                    </table>
                    
                    {clients.length===0 && lastSearchValue!== null && !loading?(
                        <p className='notFound'><Warning width='20px'/>No se encontraron registros con el filtro especificado</p>
                    ):null}

                </div>

            </div>

            {editPhonesClient && (
                <ModalWindow closeMethod={() => setEditPhonesClient(null)} width="400px">
                    <h2 className="title">Teléfonos del cliente</h2>
                    <table className="fullWidth">
                        <tbody>
                            {editPhonesClient.contacto.phones?.length > 0 ? (
                                editPhonesClient.contacto.phones.map((phone, index) => (
                                    <tr key={index}>
                                        <td>{phone}</td>
                                        <td align="right">
                                            <a onClick={() => deletePhoneFromClient(editPhonesClient._id, phone)}>
                                                <Trash size={18}/>
                                            </a>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td>Sin teléfonos registrados</td></tr>
                            )}
                        </tbody>
                    </table>
                </ModalWindow>
            )}
        </div>
    );
}

export default ClientsSearch;